import clsx from 'clsx'
import React, {useCallback, useMemo} from 'react'
import {useSearchParams} from 'react-router-dom'
import {DEFAULT_PAGE, LAPTOP_MIN_WIDTH, TABLET_BREAKPOINT} from '../../../constants'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import {useIntl} from 'react-intl'
import UseRoutesPermission from '../../../hooks/UseRoutesPermission'

export type DataTab = {label: string; value: string; count: number; active?: boolean}

type Props = {
  children: any
  keyCheckActive: string
  dataTabs: DataTab[]
  childrenTab?: any
  classNameTabs?: string
  classNameChild?: string
  classNameChildTabs?: string
  disableTabAll?: boolean
  isClaim?: boolean
  isOrder?: boolean
  isShippingAddress?: boolean
  childrenEqualTab?: any
  setShowTrackingNumberClaimModal?: any
  setShowModalUploadUspsClaim?: any
}

const TableTabs: React.FC<Props> = ({
  children,
  keyCheckActive,
  dataTabs,
  childrenTab,
  classNameTabs = '',
  classNameChild = '',
  classNameChildTabs = '',
  disableTabAll = false,
  childrenEqualTab,
  setShowTrackingNumberClaimModal,
  setShowModalUploadUspsClaim,
  isClaim = false,
  isOrder = false,
  isShippingAddress = false,
}) => {
  const intl = useIntl()
  const {width} = useWindowDimensions()
  const layoutBreakpoint =
    isClaim || isOrder ? LAPTOP_MIN_WIDTH : isShippingAddress ? 400 : TABLET_BREAKPOINT
  const [searchParams, setSearchParams] = useSearchParams()

  const tabsInit = useMemo(() => {
    const tabs = disableTabAll
      ? dataTabs
      : [
          {
            label: 'All',
            value: '',
            count: dataTabs.reduce((initTab, currentTab) => (initTab += currentTab.count), 0),
          },
          ...dataTabs,
        ]
    return tabs
  }, [dataTabs, disableTabAll])

  const newTabs = useMemo(() => {
    const valueCheckActive = searchParams.get(keyCheckActive)
    let tabsNew: Array<{}> = []

    if (!valueCheckActive) {
      tabsNew = tabsInit.map((tab: any, key: number) => {
        tab.active = key === 0
        return tab
      })
    } else {
      tabsNew = tabsInit.map((tab: any) => {
        tab.active = tab.value === valueCheckActive
        return tab
      })
    }

    return tabsNew
  }, [tabsInit, searchParams, keyCheckActive])

  const deleteParamEmpty = useCallback(
    (name) => {
      if (!searchParams.get(name)) {
        searchParams.delete(name)
      }
    },
    [searchParams]
  )

  const handleChangeTab = useCallback(
    (valueCheckActive) => {
      searchParams.set('page', DEFAULT_PAGE)
      searchParams.set(keyCheckActive, valueCheckActive)
      deleteParamEmpty('status')
      deleteParamEmpty('search_text')
      setSearchParams(searchParams, {replace: true})
    },
    [deleteParamEmpty, keyCheckActive, searchParams, setSearchParams]
  )
  const {routes} = UseRoutesPermission()

  return (
    <>
      <div
        className={clsx('d-flex justify-content-between align-items-center flex-3xl-row-reverse', {
          row: isShippingAddress ? width <= 400 : width < layoutBreakpoint,
          'flex-row-reverse': isShippingAddress ? width > 400 : width >= layoutBreakpoint,
        })}
      >
        {isClaim && (
          <div className='claim mb-2 mt-4 d-flex flex-row'>
            <div
              className={'btn btn-advanced-secondary me-3'}
              onClick={() => setShowModalUploadUspsClaim(true)}
            >
              {intl.formatMessage({id: 'UPLOAD_USPS_CLAIMS'})}
            </div>
            {routes.CLAIMS_CREATE.hasPermission && (
              <div
                className='btn btn-advanced-primary'
                onClick={() => setShowTrackingNumberClaimModal(true)}
              >
                {intl.formatMessage({id: 'START_A_NEW_CLAIM'})}
              </div>
            )}
          </div>
        )}

        {/* col-lg-3 order-lg-2 */}
        <div className={clsx({[classNameChildTabs]: !!classNameChildTabs})}>{childrenTab}</div>
        {/* col-lg-9 order-lg-1 */}
        <div className={clsx('table-tabs', {[classNameTabs]: !!classNameTabs})}>
          {newTabs.map((tab: any, key) => (
            <div
              className={clsx('table-tabs__tab', {active: tab.active})}
              key={key}
              onClick={() => handleChangeTab(tab.value)}
            >
              <div>{intl.formatMessage({id: tab.label.toUpperCase().replaceAll(' ', '_')})}</div>
              {tab.count > 0 && (
                <div className={clsx('table-tabs__tab__count', {active: tab.active})}>
                  {tab.count}
                </div>
              )}
            </div>
          ))}
          {childrenEqualTab}
        </div>
      </div>

      <div
        className={clsx('rounded-start-0 d-flex flex-column flex-column-fluid mt-sm-0', {
          [classNameChild]: !!classNameChild,
          'mt-3': !isShippingAddress && !classNameChild,
        })}
      >
        {children}
      </div>
    </>
  )
}

export {TableTabs}
